import Vue from 'vue'
import Component from './RepairProdPicker.vue'

const Constructor = Vue.extend(Component)

let instance = null

export function pickRepairProd(categoryId, selectedId) {
  if (instance) {
    instance.$destroy()
    instance = null
  }
  instance = new Constructor({ propsData: { categoryId, value: selectedId } })
  instance.$mount() // 不插入 body，让 Vue 自己管
  return instance.open().finally(() => {
    instance.$destroy()
    instance = null
  })
}
